<template>
  <div class="general-page">
    <h1>SMS Login</h1>

    <p>We'll send you a text message with a code to login to your account.</p>
    <div class="qform2022 full">
      <p
        v-if="first(errors) || errors.recaptcha_response"
        class="notice error live"
      >
        <span class="icon-attention redicon" />
        {{ first(errors) }}
      </p>

      <form @submit.prevent="post">
        <div class="generic-inputs">
          <label>Phone Number*</label>
          <input
            v-model="number"
            type="tel"
            name="phone_number"
            placeholder="Phone Number"
          >
        </div>


        <div v-if="recaptchaFields.required">
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="recaptchaKey"
            @verify="recaptchaCompleted"
          />
          <br>
        </div>

        <div
          v-if="loading"
          class="twobuttons"
        >
          <img
            src="/assets/images/loading.gif"
            style="width:200px;"
          >
        </div>
        <div
          v-else
          class="twobuttons"
        >
          <button class="button">
            Text me
          </button>
          <span>or</span>
          <button
            class="button clear"
            onclick="event.preventDefault(); location.href='/contact-us'"
          >
            Contact us instead
          </button>
        </div>
      </form>
    </div>
    <br>
    <p class="last">
      <a
        href="/portal"
        class="normal-link"
      >Create an account</a> if you don't have one or <router-link :to="{ name: 'login'}">
        login
      </router-link>.
    </p>
  </div>
</template>

<script>
import { ref } from 'vue';
import authComposable from "./AuthComposable.js";
import axios from '../../axios.js'
import {VueRecaptcha} from "vue-recaptcha";
import { useRouter } from 'vue-router';

export default {
    components: {
        VueRecaptcha
    },
    setup() {
        const router = useRouter();
        const loading = ref(false);
        const number = ref(null);
        const errors = ref([]);
        const { recaptchaFields, resetCaptcha, recaptchaKey, first, recaptchaCompleted } = authComposable();

        const post = () => {
            loading.value = true;
            errors.value = [];

            const data = {
                number: number.value,
                recaptcha_response: recaptchaFields.response,
            };

            axios({
                method: 'post',
                url: '/auth/sms-login',
                data: data,
            }).then(response => {
                if (!response.data.success) {
                    errors.value = response.data.errors;
                } else {
                    router.push({
                        name: 'sms-login-code',
                        query: {
                            route: btoa(response.data.route),
                        },
                    });
                }

                if (errors.value.recaptcha_response) {
                    recaptchaFields.required = true;
                }
                loading.value = false;
            }).catch(error => {
                console.log(error);
                errors.value = { general: ['Something went wrong; please try again later.'] };
                loading.value = false;
            }).then(() => {
                resetCaptcha();
            });
        };

        return {
            loading,
            number,
            errors,
            post,
            recaptchaKey,
            first,
            recaptchaCompleted,
            recaptchaFields
        };
    },
};
</script>